import "./modal.scss";

import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

const ModalBlock = props => (
  <div className="modalBlock">
    <label>{props.label}</label>
    {props.children}
  </div>
);

ModalBlock.propTypes = {
  label: PropTypes.string,
  children: PropTypeShapes.elementOrArray
};

export default ModalBlock;
